import { render, staticRenderFns } from "./UsersMosaicView.vue?vue&type=template&id=0528575a&"
import script from "./UsersMosaicView.vue?vue&type=script&lang=ts&"
export * from "./UsersMosaicView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports